import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { db } from '../firebase'; // Adjust import path as needed
import { collection, getDocs, query, where } from 'firebase/firestore';
import CountUp from 'react-countup';
import './Protected-Pages/protected.css';
import './LoginForm/LoginForm.css';
import { UserAuth } from '../authContext';
const MainPage = () => {
    const navigate = useNavigate();
    const [projects, setProjects] = useState([]);
    const [activeCount, setActiveCount] = useState(0);
    const [inactiveCount, setInactiveCount] = useState(0);
    const { user } = UserAuth();

    const handleSignInClick = () => {
        navigate('/login'); // Adjust the route as necessary
    };
    const fetchUserFromFirestore = async (email) => {
        const userQuery = query(collection(db, 'users'), where('email', '==', email));
        const userSnapshot = await getDocs(userQuery);
        if (!userSnapshot.empty) {
            return userSnapshot.docs[0].data();
        }
        return null;
    };
    useEffect(() => {
        const handleLoginFlow = async () => {
            if (user) {
                navigate('/home');
            }
        };

        handleLoginFlow();
    }, [user, navigate]);
    useEffect(() => {
        const fetchProjects = async () => {
            try {
                const q = query(collection(db, 'Projects')); // Adjust query based on your needs
                const querySnapshot = await getDocs(q);
                const projectsList = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                setProjects(projectsList);

                // Count active and inactive projects
                const activeProjects = projectsList.filter(project => project.active);
                const inactiveProjects = projectsList.filter(project => !project.active);

                setActiveCount(activeProjects.length);
                setInactiveCount(inactiveProjects.length);
            } catch (error) {
                console.error("Error fetching projects:", error);
            }
        };

        fetchProjects();
    }, []);

    return (
        <div className='mainpage'>            
            <div className="content main">
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textAlign: 'center'
                }}>
                    <div style={{ fontSize: '100px', marginBottom: '10px' }}>
                        <CountUp end={projects.length} duration={2} />
                    </div>
                    <div>Projects</div>
                </div>
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textAlign: 'center'
                }}>
                    <div style={{ fontSize: '100px', marginBottom: '10px' }}>
                        <CountUp end={activeCount} duration={2} />
                    </div>
                    <div>Projects in Progress</div>
                </div>
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textAlign: 'center'
                }}>
                    <div style={{ fontSize: '100px', marginBottom: '10px' }}>
                        <CountUp end={inactiveCount} duration={2} />
                    </div>
                    <div>Completed Projects</div>
                </div>
            </div>
            <button className='sign-in-button' style={{position: 'absolute', top: '30px', left:'25%'}} onClick={handleSignInClick}>
                <p className='text a'>Proceed to Login Page</p>
            </button>
        </div>
    );
};

export default MainPage;
